import ImageTemplateProduct from './components/ImageTemplateProduct'
import ImageTemplateLoader from './components/ImageTemplateLoader'

export default {
    install(Vue, option) {
        Vue.component('ImageTemplateProduct', ImageTemplateProduct);
        Vue.component('ImageTemplateLoader', ImageTemplateLoader);
    }
};